module.exports = __webpack_public_path__ + "img/mission-impossible-6.9adccb0f.jpg";